import React from 'react';
import { qualifiedLeads } from '../../mock';

const gradeStyle = (g) => {
  if (g === 'MQL') return 'bg-[#4ECDC4] text-[#0F1C40]';
  if (g === 'Hot') return 'bg-[#FF6B35] text-white';
  if (g === 'Warm') return 'bg-[#FBBC05] text-[#0F1C40]';
  return 'bg-white/15 text-[#F1EDE4]';
};

export default function QualifiedLeads() {
  return (
    <section className="py-20 lg:py-32 bg-[#0F1C40] text-[#F1EDE4] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-10 lg:mb-14">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-white/50 mb-4">
              <span className="w-6 h-px bg-[#4ECDC4]" />
              <span>Qualified Lead Register</span>
            </div>
            <h2 className="text-4xl lg:text-6xl tracking-tight leading-[1.02] font-medium">
              Top leads by <span className="font-serif italic font-normal">score.</span>
            </h2>
            <p className="mt-3 text-white/70">Ranked by scoring model · MQL threshold ≥ 80 · sorted highest to lowest.</p>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-8">
          {/* Score distribution mini-chart */}
          <div className="lg:col-span-4 bg-[#12234C] border border-white/10 rounded-2xl p-8 reveal">
            <div className="text-[10px] font-mono uppercase tracking-widest text-white/50 mb-4">Score distribution</div>
            <div className="flex items-end gap-1.5 h-40">
              {[3, 5, 4, 6, 9, 12, 8, 6].map((h, i) => (
                <div key={i} className="flex-1 flex flex-col justify-end">
                  <div className="rounded-t-sm" style={{ height: `${h * 8}%`, background: i > 5 ? '#4ECDC4' : i > 3 ? '#FF6B35' : i > 1 ? '#FBBC05' : '#4285F4' }} />
                </div>
              ))}
            </div>
            <div className="grid grid-cols-4 gap-1 mt-3 text-[9px] font-mono text-white/50">
              <span>20-39</span><span className="text-center">40-59</span><span className="text-center">60-79</span><span className="text-right">80-99</span>
            </div>
            <div className="grid grid-cols-2 gap-3 mt-8 pt-6 border-t border-white/10">
              <div><div className="flex items-center gap-1.5 text-xs text-white/80"><span className="w-2 h-2 bg-[#4ECDC4] rounded-full" />MQL</div><div className="text-2xl font-medium tabular">8</div></div>
              <div><div className="flex items-center gap-1.5 text-xs text-white/80"><span className="w-2 h-2 bg-[#FF6B35] rounded-full" />Hot</div><div className="text-2xl font-medium tabular">7</div></div>
              <div><div className="flex items-center gap-1.5 text-xs text-white/80"><span className="w-2 h-2 bg-[#FBBC05] rounded-full" />Warm</div><div className="text-2xl font-medium tabular">9</div></div>
              <div><div className="flex items-center gap-1.5 text-xs"><span className="w-2 h-2 bg-white/10 rounded-full" />Cold</div><div className="text-2xl font-medium tabular">6</div></div>
            </div>
          </div>

          <div className="lg:col-span-8 bg-[#12234C] border border-white/10 rounded-2xl overflow-hidden reveal">
            <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-4 border-b border-white/10 text-[10px] font-mono uppercase tracking-widest text-white/50">
              <div className="col-span-1">#</div>
              <div className="col-span-3">Name</div>
              <div className="col-span-3">Company</div>
              <div className="col-span-2">Title</div>
              <div className="col-span-1">Channel</div>
              <div className="col-span-1 text-right">Score</div>
              <div className="col-span-1 text-right">Grade</div>
            </div>
            <div className="max-h-[420px] overflow-y-auto">
              {qualifiedLeads.map((l) => (
                <div key={l.n} className="grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-4 px-6 py-3 border-b border-white/10 items-center hover:bg-[#12234C] transition">
                  <div className="col-span-1 font-mono text-xs text-white/50">{l.n}</div>
                  <div className="col-span-3 text-sm font-medium text-[#F1EDE4]">{l.name}</div>
                  <div className="col-span-3 text-sm text-white/80">{l.company}</div>
                  <div className="col-span-2 text-xs text-white/50">{l.title}</div>
                  <div className="col-span-1 text-xs font-mono text-white/50">{l.channel}</div>
                  <div className="col-span-1 text-right font-mono text-sm tabular font-semibold text-[#F1EDE4]">{l.score}</div>
                  <div className="col-span-1 flex justify-end">
                    <span className={`text-[10px] font-mono px-2 py-1 rounded-full ${gradeStyle(l.grade)}`}>{l.grade}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
